<script setup>
// Conversations by team (live overview): every team with its open and unattended conversations, most open first,
// then by name. The table itself is LiveConversationsTable.
import { computed } from 'vue';
import LiveConversationsTable from './LiveConversationsTable.vue';

const props = defineProps({
  teams: {
    type: Array,
    default: () => [],
  },
  teamMetrics: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const getTeamMetrics = id =>
  props.teamMetrics.find(metrics => metrics.team_id === Number(id)) || {};

const rows = computed(() =>
  props.teams
    .map(team => {
      const metric = getTeamMetrics(team.id);
      return {
        id: team.id,
        name: team.name,
        open: metric.open || 0,
        unattended: metric.unattended || 0,
      };
    })
    .sort((a, b) => b.open - a.open || a.name.localeCompare(b.name))
);
</script>

<template>
  <LiveConversationsTable
    :rows="rows"
    :is-loading="isLoading"
    :name-header="$t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.TABLE_HEADER.TEAM')"
    page-size-key="report_overview_team_table_page_size"
    count-key="POLARIS_REPORTS.LIVE_TABLE.TEAMS_COUNT"
    showing-key="POLARIS_REPORTS.LIVE_TABLE.TEAMS_SHOWING"
    :empty-text="$t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.NO_TEAMS')"
  />
</template>
